/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * LSQ Service API
 * Device attributes and related endpoints for Infinity Learn LSQ service.

 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DeviceAttributesResponse,
  GetDeviceAttributesParams,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns device attribute metadata for the given device model name.
 * @summary Get device attributes by model
 */
export const getDeviceAttributes = (
  params: GetDeviceAttributesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DeviceAttributesResponse>(
    { url: `/lsq/device-attributes`, method: "GET", params, signal },
    options,
  );
};

export const getGetDeviceAttributesQueryKey = (
  params?: GetDeviceAttributesParams,
) => {
  return [`/lsq/device-attributes`, ...(params ? [params] : [])] as const;
};

export const getGetDeviceAttributesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeviceAttributes>>,
  TError = void,
>(
  params: GetDeviceAttributesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeviceAttributes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDeviceAttributesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeviceAttributes>>
  > = ({ signal }) => getDeviceAttributes(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeviceAttributes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeviceAttributesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeviceAttributes>>
>;
export type GetDeviceAttributesQueryError = void;

export function useGetDeviceAttributes<
  TData = Awaited<ReturnType<typeof getDeviceAttributes>>,
  TError = void,
>(
  params: GetDeviceAttributesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeviceAttributes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceAttributes>>,
          TError,
          Awaited<ReturnType<typeof getDeviceAttributes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeviceAttributes<
  TData = Awaited<ReturnType<typeof getDeviceAttributes>>,
  TError = void,
>(
  params: GetDeviceAttributesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeviceAttributes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceAttributes>>,
          TError,
          Awaited<ReturnType<typeof getDeviceAttributes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeviceAttributes<
  TData = Awaited<ReturnType<typeof getDeviceAttributes>>,
  TError = void,
>(
  params: GetDeviceAttributesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeviceAttributes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get device attributes by model
 */

export function useGetDeviceAttributes<
  TData = Awaited<ReturnType<typeof getDeviceAttributes>>,
  TError = void,
>(
  params: GetDeviceAttributesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeviceAttributes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeviceAttributesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
